const ded = `
<h1>Personal Data Processing Policy</h1>
<p><strong>DressDown.me</strong><br><em>Effective Date: 01.05.2025</em></p>

<h2>General Provisions</h2>
<p>This Personal Data Processing Policy (hereinafter referred to as the "Policy") regulates the procedures for collecting, storing, using, and transferring personal data of users of the website <a href="https://dressdown.me">https://dressdown.me</a> (hereinafter referred to as the "Site") in accordance with the General Data Protection Regulation (GDPR), the ePrivacy Directive, and other applicable European Union legislation.</p>
<p>We respect your right to privacy and undertake to process your personal data responsibly, securely, and lawfully.</p>

<h2>Data Controller</h2>
<p>The data controller responsible for processing is:<br>
Prowenta Trade s.r.o<br>
Email: <a href="mailto:support@dressdown.me">support@dressdown.me</a><br>
Legal address: Vikova 532/8, Žižkov (Praha 3), Prague, Czech Republic</p>

<h2>What Data We Process</h2>
<p>We may collect and process the following categories of personal data:</p>
<ul>
  <li>Contact data: email</li>
  <li>Account data: login, password (encrypted), profile settings</li>
  <li>Payment data: processed by a payment service provider partner</li>
  <li>Technical data: IP address, geolocation, device and browser type, cookies</li>
  <li>Age: for age verification purposes to comply with laws regarding the processing of minors' data</li>
  <li>Images, including generated images if you use visual content generation services</li>
</ul>

<h2>Purposes of Personal Data Processing</h2>
<p>Your personal data is processed for lawful purposes including:</p>
<ul>
  <li>Providing access to the site's functionality and services</li>
  <li>Ensuring the operation of the user account</li>
  <li>Fulfilling contractual obligations (payment, delivery, feedback)</li>
  <li>Conducting analysis, improving services, and personalizing content</li>
  <li>Lawful identification and age verification of the user</li>
  <li>Ensuring information security and fraud prevention</li>
  <li>Compliance with legal obligations including tax and commercial regulations</li>
</ul>

<h2>Legal Grounds for Processing</h2>
<p>Processing of your data may be based on:</p>
<ul>
  <li>Your consent (Art. 6(1)(a) GDPR)</li>
  <li>Necessity for contract performance (Art. 6(1)(b) GDPR)</li>
  <li>Legitimate interests of the controller (e.g., fraud protection – Art. 6(1)(f) GDPR)</li>
  <li>Compliance with legal obligations (Art. 6(1)(c) GDPR)</li>
</ul>

<h2>Processing Data of Minors</h2>
<p>To ensure compliance with age restrictions, the DressDown.me platform uses automated technologies for image and personal data analysis. This check is performed using external partner solutions, including AI Vision Apps – Age Detection API, integrated via the RapidAPI platform. These technologies are based on computer vision and machine learning algorithms to determine if the user has reached the minimum age of 18.</p>
<p>Image processing is performed exclusively in encrypted form and limited to a single request. Images uploaded by users are not stored on the DressDown.me platform or by third-party partners and are not used for identification or biometric template creation.</p>
<p>If a user is found to be underage, access to the platform's functionality is blocked in accordance with applicable European Union legislation and DressDown.me internal rules.</p>

<h2>Data Transfer to Third Parties</h2>
<p>We may transfer your personal data to the following categories of recipients:</p>
<ul>
  <li>Payment providers</li>
  <li>Hosting providers and IT service suppliers</li>
  <li>Partners for identity and age verification</li>
  <li>Competent government authorities – only as required by law</li>
  <li>Legal advisors in case of disputes</li>
</ul>
<p>All transferred data is protected by confidentiality agreements and complies with GDPR requirements (including international data transfers under EU standard contractual clauses).</p>

<h2>Data Retention Periods</h2>
<p>Data is stored:</p>
<ul>
  <li>While your account exists and up to 5 years after deletion for legal compliance</li>
  <li>Activity data (e.g., logs) – up to 1 year</li>
  <li>Financial documents – 6 to 10 years, depending on legislation</li>
</ul>
<p>After the retention period, data is deleted.</p>

<h2>Your Rights</h2>
<p>You have the right to:</p>
<ul>
  <li>Access your data</li>
  <li>Correct inaccurate or outdated data</li>
  <li>Delete your data (right to be forgotten)</li>
  <li>Restrict or object to processing</li>
  <li>Withdraw consent at any time</li>
  <li>File a complaint with a supervisory authority</li>
</ul>
<p>Requests can be sent to email: <a href="mailto:support@dressdown.me">support@dressdown.me</a></p>

<h2>Data Security</h2>
<p>We apply organizational and technical measures to protect data:</p>
<ul>
  <li>SSL encryption</li>
  <li>Protection against unauthorized access</li>
  <li>Data stored only in verified EU data centers</li>
  <li>Regular audits and security system updates</li>
</ul>

<h2>Policy Changes</h2>
<p>We may update this Policy. We will notify you of significant changes via the website or email. We recommend periodically checking the policy's current version.</p>

<h2>Contact Information</h2>
<p>If you have questions about your privacy or data processing:<br>
Email: <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a><br>
Legal address: Vikova 532/8, Žižkov (Praha 3), Prague, Czech Republic</p>
`;

export default ded
